import React from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../AppContext";

const SoaImplementedModal = ({ isOpen, category, categoryLabel, measureCount, onConfirm }) => {
  const { t } = useTranslation();
  const { closeModal } = useAppContext();

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    closeModal();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
      onClick={closeModal}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '30px',
          maxWidth: '480px',
          width: '90%',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{
            width: '60px',
            height: '60px',
            margin: '0 auto 15px',
            backgroundColor: '#c6efce',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <i className="icon-SoA" style={{ fontSize: '26px', color: '#006101' }} />
          </div>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '600' }}>
            {t('soa_all_measures_done_title')}
          </h2>
          <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
            {t('soa_all_measures_done_description')}
          </p>
        </div>

        {/* Category info */}
        <div style={{
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          padding: '15px',
          marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <span style={{ fontWeight: '500', fontSize: 13, color: '#666' }}>{t('category')}</span>
            <span style={{ fontWeight: '600', fontSize: 14 }}>
              {categoryLabel || category}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontWeight: '500', fontSize: 13, color: '#666' }}>{t('measures')}</span>
            <span style={{
              fontWeight: '600',
              fontSize: 14,
              color: '#006101'
            }}>
              {measureCount} / {measureCount} {t('implemented').toLowerCase()}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={handleConfirm}
            style={{
              flex: 1,
              padding: '12px 20px',
              backgroundColor: 'var(--text-color)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--text-color)'}
          >
            <i className="icon-check" style={{ marginRight: '8px' }} />
            {t('mark_as_implemented')}
          </button>

          <button
            onClick={closeModal}
            style={{
              flex: 1,
              padding: '12px 20px',
              backgroundColor: 'white',
              color: 'var(--text-color)',
              border: '2px solid var(--text-color)',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--text-color)';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'var(--text-color)';
            }}
          >
            {t('not_now')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SoaImplementedModal;
